import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import useComponentDidMount from 'Hooks/useComponentDidMount';
import { noop } from 'Helpers/PropTypes';
import {
  AttachmentsSectionRebranded,
} from 'Components/ComponentLibrary/Components/Uncategorized/AttachmentsSectionRebranded';
import RichTextDisplayPicker
  from 'Components/ComponentLibrary/Organisms/MessageList/MessageListItem/MessageContent/Content/RichTextDisplayPicker';

const useStylesNoMargin = buildUseStyles('DefaultMessageContentNoMargin', ((theme) => ({
  root: {
    paddingBottom: theme.spacing(1),
  },
})));

const DefaultMessageContent = ({
  messageResource,
  onLoadComplete,
}) => {
  const classes = useStylesNoMargin();

  useComponentDidMount(() => {
    onLoadComplete();
  });

  return (
    <div className={classes.root}>
      <RichTextDisplayPicker
        resource={messageResource}
        content={messageResource.attr('content')}
      />
      {messageResource?.attr('attachments') && (
        <AttachmentsSectionRebranded
          className={classes.attachments}
          attachmentsCollection={messageResource?.attr('attachments')}
          eventCategory={'Messages'}
        />
      )}
    </div>
  );
};

DefaultMessageContent.defaultProps = {
  onLoadComplete: noop,
};

DefaultMessageContent.propTypes = {
  messageResource: PropTypes.object.isRequired,
  onLoadComplete: PropTypes.func,
};

export default DefaultMessageContent;
